import IAuthUserRepository from 'domain/interfaces/repositories/IAuthUserRepository'

export const refreshTokenAuthUserCommand = (repository: IAuthUserRepository, token: string) => {
  return repository.refreshToken(token)
}
